import React, { useMemo } from 'react'
import { getContextName, decodeItemURIComponents } from 'Helper/routeHelpers'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import {
  addScreenType
} from './DesignerHelpers.jsx'

const withWindowScreenWorkflowConfigs = () => {
  return WrappedComponent => {
    return (props) => {
      const { pathname } = useLocation()

      const screenContext = useMemo(() => {
        return getContextName(pathname)
      }, [pathname])

      const {
        workflows: patientDisplayWorkflows = [],
        windows: patientDisplayWindows = [],
        screens: patientDisplayScreens = [],
        workflows_id: patientDisplayWorkflowsId = null,
        screens_id: patientDisplayScreensId = null,
        windows_id: patientDisplayWindowsId = null
      } = useSelector(state => state.appConfig?.patientDisplay) || {}

      const {
        workflows: adminDisplayWorkflows = [],
        windows: adminDisplayWindows = [],
        screens: adminDisplayScreens = [],
        workflows_id: adminDisplayWorkflowsId = null,
        screens_id: adminDisplayScreensId = null,
        windows_id: adminDisplayWindowsId = null
      } = useSelector(state => state.appConfig?.adminDisplay) || {}

      const {
        workflows: nurseDashboardWorkflows = [],
        windows: nurseDashboardWindows = [],
        screens: nurseDashboardScreens = [],
        workflows_id: nurseDashboardWorkflowsId = null,
        screens_id: nurseDashboardScreensId = null,
        windows_id: nurseDashboardWindowsId = null
      } = useSelector(state => state.appConfig?.nurseDashboard) || {}

      const windows = useMemo(() => {
        switch (screenContext) {
          case 'nurseDashboard':
            return nurseDashboardWindows.map(addScreenType).map(decodeItemURIComponents)
          case 'adminDisplay':
            return adminDisplayWindows.map(addScreenType).map(decodeItemURIComponents)
          case 'patientDisplay':
            return patientDisplayWindows.map(addScreenType).map(decodeItemURIComponents)
          default:
            return []
        }
      }, [
        screenContext,
        nurseDashboardWindows,
        adminDisplayWindows,
        patientDisplayWindows
      ])

      const windowsId = useMemo(() => {
        switch (screenContext) {
          case 'nurseDashboard':
            return nurseDashboardWindowsId
          case 'adminDisplay':
            return adminDisplayWindowsId
          case 'patientDisplay':
            return patientDisplayWindowsId
          default:
            return []
        }
      }, [
        screenContext,
        nurseDashboardWindowsId,
        adminDisplayWindowsId,
        patientDisplayWindowsId
      ])

      const screens = useMemo(() => {
        switch (screenContext) {
          case 'nurseDashboard':
            return nurseDashboardScreens.map(addScreenType).map(decodeItemURIComponents)
          case 'adminDisplay':
            return adminDisplayScreens.map(addScreenType).map(decodeItemURIComponents)
          case 'patientDisplay':
            return patientDisplayScreens.map(addScreenType).map(decodeItemURIComponents)
          default:
            return []
        }
      }, [
        screenContext,
        nurseDashboardScreens,
        adminDisplayScreens,
        patientDisplayScreens
      ])

      const screensId = useMemo(() => {
        switch (screenContext) {
          case 'nurseDashboard':
            return nurseDashboardScreensId
          case 'adminDisplay':
            return adminDisplayScreensId
          case 'patientDisplay':
            return patientDisplayScreensId
          default:
            return []
        }
      }, [
        screenContext,
        nurseDashboardScreensId,
        adminDisplayScreensId,
        patientDisplayScreensId
      ])

      const workflows = useMemo(() => {
        switch (screenContext) {
          case 'nurseDashboard':
            return nurseDashboardWorkflows.map(addScreenType).map(decodeItemURIComponents)
          case 'adminDisplay':
            return adminDisplayWorkflows.map(addScreenType).map(decodeItemURIComponents)
          case 'patientDisplay':
            return patientDisplayWorkflows.map(addScreenType).map(decodeItemURIComponents)
          default:
            return []
        }
      }, [screenContext])

      const workflowsId = useMemo(() => {
        switch (screenContext) {
          case 'nurseDashboard':
            return nurseDashboardWorkflowsId
          case 'adminDisplay':
            return adminDisplayWorkflowsId
          case 'patientDisplay':
            return patientDisplayWorkflowsId
          default:
            return []
        }
      }, [
        screenContext,
        nurseDashboardWorkflowsId,
        adminDisplayWorkflowsId,
        patientDisplayWorkflowsId
      ])

      return <WrappedComponent
        contextWindowConfigs={windows}
        contextWindowConfigId={windowsId}
        contextScreenConfigs={screens}
        contextScreensConfigsId={screensId}
        contextWorkflowConfigs={workflows}
        contextWorkflowConfigsId={workflowsId}
        {...props}
      />
    }
  }
}

export default withWindowScreenWorkflowConfigs